/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { useEffect, useState } from "react";
import type { AnimationNames } from "./lottie-animation.helper";
import type { AnimationData, RendererSettings } from "./lottie-animation.types";
import { importLottie } from "./importLottie.func";
import { useCosmosComponentContext } from "@components/context/ComponentContext";

type LottieAnimationProps = { lottie?: AnimationNames; className?: string; rendererSettings?: RendererSettings };

export const LottieAnimation = ({
	lottie,
	className,
	rendererSettings,
}: LottieAnimationProps): React.JSX.Element | null => {
	const { Lottie } = useCosmosComponentContext();
	const [animationData, setAnimationData] = useState<AnimationData | null>(null);

	useEffect(() => {
		setAnimationData(null);
		if (lottie?.length) {
			importLottie(lottie)
				.then((animationData) => setAnimationData(animationData))
				.catch((e) => {
					throw e;
				});
		}
	}, [lottie, setAnimationData]);

	if (!lottie || !Lottie) return null;

	return <Lottie animationData={animationData} rendererSettings={rendererSettings} className={className} />;
};
